import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/buyers/new')({
  beforeLoad: () => {
    throw redirect({ to: '/customers/new' });
  },
});
